<template>
  <a class="wt-google-signin">
    <img
      src="/resources/img/google/btn_google_signin_dark_normal_web@2x.png"
      class="-normal"
      loading="lazy"
      alt="Sign in with Google"
    />
    <img
      src="/resources/img/google/btn_google_signin_dark_focus_web@2x.png"
      class="-focus"
      loading="lazy"
      alt="Sign in with Google"
    />
    <img
      src="/resources/img/google/btn_google_signin_dark_pressed_web@2x.png"
      class="-active"
      loading="lazy"
      alt="Sign in with Google"
      draggable="false"
    />
  </a>
</template>

<script>
export default {
  name: 'wtGoogleSignin',
};
</script>

<style lang="scss" scoped>
.wt-google-signin {
  position: relative;
  cursor: pointer;
  width: 191px;
  height: 46px;
  user-select: none;

  img {
    position: absolute;
    top: 0;
    width: inherit;
    opacity: 0;
  }

  .-normal {
    opacity: 1;
  }

  &:hover,
  &:focus,
  &:active {
    .-normal {
      opacity: 0;
    }
  }

  &:hover,
  &:focus {
    .-focus {
      opacity: 1;
    }
  }

  &:active {
    .-focus {
      opacity: 0;
    }
    .-active {
      opacity: 1;
    }
  }
}
</style>
